import {
  GETSETUPACCOUNT,
  CREATESETUPACCOUNT,
  UPDATESETUPACCOUNT,
  DELETESETUPACCOUNT,
  GETSETUPACCOUNTHEAD,
  GETSETUPACCOUNTHEADBYHID,
  CREATESETUPACCOUNTHEAD,
  UPDATESETUPACCOUNTHEAD,
  DELETESETUPACCOUNTHEAD,
  GETSETUPACCOUNTTYPE,
  CREATESETUPACCOUNTTYPE,
  UPDATESETUPACCOUNTTYPE,
  DELETESETUPACCOUNTTYPE,
  GETSETUPACCOUNTSUBTYPE,
  CREATESETUPACCOUNTSUBTYPE,
  UPDATESETUPACCOUNTSUBTYPE,
  DELETESETUPACCOUNTSUBTYPE,
  GETSETUPACCOUNTCURRENCY,
  CREATESETUPACCOUNTCURRENCY,
  UPDATESETUPACCOUNTCURRENCY,
  DELETESETUPACCOUNTCURRENCY,
  SET_SELECTED_CURRENCY,
  GETALLACCOUNTHEAD,
  CREATALLACCOUNTS,
  CREATEFINANCIALYEAR,
  GETFINANCIALYEAR,
  UPDATEFINANCIALYEAR,
  DELETEFINANCIALYEAR,
  CREATE_COST_CENTER,
  GET_COST_CENTER,
  UPDATE_COST_CENTER,
  DELETE_COST_CENTER,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup Account Cases
    case GETSETUPACCOUNT:
      return {
        ...state,
        accountsList: action.payload.data,
      };
    case CREATESETUPACCOUNT:
      return {
        ...state,
        setupAccountCreateStatus: action.payload.success,
      };
    case UPDATESETUPACCOUNT:
      return {
        ...state,
        setupAccountUpdateStatus: action.payload.success,
      };
    case DELETESETUPACCOUNT:
      return {
        ...state,
        setupAccountDeleteStatus: action.payload.success,
      };

    case GETALLACCOUNTHEAD:
      return {
        ...state,
        allAccountHeadList: action.payload.data,
      };
    case GETSETUPACCOUNTHEAD:
      return {
        ...state,
        accountHeadList: action.payload.data,
      };

    case GETSETUPACCOUNTHEADBYHID:
      return {
        ...state,
        accountHeadbyHidList: action.payload.data,
      };
    case CREATESETUPACCOUNTHEAD:
      return {
        ...state,
        setupAccountHeadCreateStatus: action.payload.success,
      };

    case CREATALLACCOUNTS:
      return {
        ...state,
        setupAllAccountCreateStatus: action.payload.success,
      };
    case UPDATESETUPACCOUNTHEAD:
      return {
        ...state,
        setupAccountHeadUpdateStatus: action.payload.success,
      };
    case DELETESETUPACCOUNTHEAD:
      return {
        ...state,
        setupAccountHeadDeleteStatus: action.payload.success,
      };

    // Setup Account Type Cases
    case GETSETUPACCOUNTTYPE:
      return {
        ...state,
        accountTypeList: action.payload.data,
      };
    case CREATESETUPACCOUNTTYPE:
      return {
        ...state,
        setupAccountTypeCreateStatus: action.payload.success,
      };
    case UPDATESETUPACCOUNTTYPE:
      return {
        ...state,
        setupAccountTypeUpdateStatus: action.payload.success,
      };
    case DELETESETUPACCOUNTTYPE:
      return {
        ...state,
        setupAccountTypeDeleteStatus: action.payload.success,
      };

    // Setup Account Sub Type Cases
    case GETSETUPACCOUNTSUBTYPE:
      return {
        ...state,
        accountSubTypeList: action.payload.data,
      };
    case CREATESETUPACCOUNTSUBTYPE:
      return {
        ...state,
        setupAccountSubTypeCreateStatus: action.payload.success,
      };
    case UPDATESETUPACCOUNTSUBTYPE:
      return {
        ...state,
        setupAccountSubTypeUpdateStatus: action.payload.success,
      };
    case DELETESETUPACCOUNTSUBTYPE:
      return {
        ...state,
        setupAccountSubTypeDeleteStatus: action.payload.success,
      };

    case SET_SELECTED_CURRENCY:
      return {
        ...state,
        selectedCurrency: action.payload,
      };

    // Setup Account Currency Cases
    case GETSETUPACCOUNTCURRENCY:
      return {
        ...state,
        currenciesList: action.payload.data,
      };
    case CREATESETUPACCOUNTCURRENCY:
      return {
        ...state,
        setupAccountCurrencyCreateStatus: action.payload.success,
      };
    case UPDATESETUPACCOUNTCURRENCY:
      return {
        ...state,
        setupAccountCurrencyUpdateStatus: action.payload.success,
      };
    case DELETESETUPACCOUNTCURRENCY:
      return {
        ...state,
        setupAccountCurrencyDeleteStatus: action.payload.success,
      };
    case CREATEFINANCIALYEAR:
      return {
        ...state,
        financialYearSaveStatus: action.payload.success,
      };

    case GETFINANCIALYEAR:
      return {
        ...state,
        financialYearList: action.payload.data,
      };

    case UPDATEFINANCIALYEAR:
      return {
        ...state,
        financialYearUpdateStatus: action.payload.success,
      };

    case DELETEFINANCIALYEAR:
      return {
        ...state,
        financialYearList: state.financialYearList.filter(
          (item) => item.id !== action.financialYearId,
        ),
        financialYearDeleteStatus: action.payload.success,
      };
    case CREATE_COST_CENTER:
      return {
        ...state,
        costCenterSaveStatus: action.payload.success,
      };
    case GET_COST_CENTER:
      return {
        ...state,
        costCenterList: action.payload.data,
      };
    case UPDATE_COST_CENTER:
      return {
        ...state,
        costCenterUpdateStatus: action.payload.success,
      };
    case DELETE_COST_CENTER:
      return {
        ...state,
        costCenterList: state.costCenterList.filter(
          (item) => item.id !== action.costCenterId,
        ),
        costCenterDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
